import React from 'react';
import { Loader2 } from 'lucide-react';
import cx from './cx';

// True when className already sets a text colour (not a text size), so the default can step aside.
const HAS_TEXT_COLOR = /(^|\s)text-(?!(2xs|xs|sm|base|lg|xl|\d?xl|\[\d))/;

export function Spinner({ className, label = 'Loading' }) {
  return (
    <span role="status" className="inline-flex items-center">
      <Loader2 className={cx('h-4 w-4 animate-spin', !HAS_TEXT_COLOR.test(className || '') && 'text-fg-muted', className)} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}

/** Full-area loading state for a route or data view. */
export function PageLoader({ label = 'Loading…', className }) {
  return (
    <div role="status" aria-live="polite" className={cx('flex min-h-[40vh] flex-col items-center justify-center gap-3 text-fg-muted', className)}>
      <Loader2 className="h-6 w-6 animate-spin" aria-hidden="true" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Skeleton({ className }) {
  return <div aria-hidden="true" className={cx('animate-pulse rounded-control bg-surface-2', className)} />;
}

export default Spinner;
